function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 29.892c8.284 0 15-6.447 15-14.4s-6.716-14.4-15-14.4c-8.284 0-15 6.447-15 14.4s6.716 14.4 15 14.4z",
  fill: "#627EEA"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.45 5.148v7.656l6.738 2.892-6.737-10.548z",
  fill: "#fff",
  fillOpacity: 0.602
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.45 5.148L8.713 15.684l6.737-2.892V5.148z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.45 20.64v5.196l6.738-8.952-6.737 3.756z",
  fill: "#fff",
  fillOpacity: 0.602
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.45 25.836V20.64l-6.737-3.756 6.737 8.952z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.45 19.44l6.738-3.756-6.737-2.892v6.648z",
  fill: "#fff",
  fillOpacity: 0.2
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M8.713 15.684l6.737 3.756v-6.648l-6.737 2.892z",
  fill: "#fff",
  fillOpacity: 0.602
});

function SvgEth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default __webpack_public_path__ + "58dc46cd5c0a72ccd9997bed4e97dd75.svg";
export { SvgEth as ReactComponent };